import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import { Filter } from '@/modules/common/filter/filter.ts'
import { Paginatable } from '@/modules/shared/helpers/http/paginatable'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { FilterService } from '@/modules/common/filter/services/filter.service'

@Component
export class FilterComponentsMixin extends Vue {
  @Prop() filter!: Filter

  @Prop() service!: FilterService

  protected get resource(): Filter['items'] {
    return this.filter.items
  }

  public get from() {
    if (!this.filter.keys) return null
    return this.service.get(this.filter.keys.from)
  }

  public set from(value: any) {
    if (this.filter.keys) {
      this.service.add(this.filter.keys.from, value)
    }
  }

  public get to() {
    if (!this.filter.keys) return null
    return this.service.get(this.filter.keys.to)
  }

  public set to(value: any) {
    if (this.filter.keys) {
      this.service.add(this.filter.keys.to, value)
    }
  }

  protected default: any = null

  private get defaultValue() {
    return this.filter.defaultValue || this.default
  }

  public get model() {
    if (!this.filter.key) return null
    return this.service.get(this.filter.key) || this.defaultValue
  }

  public set model(value: any) {
    if (this.filter.key) {
      this.service.add(this.filter.key, value)
    }
  }

  protected onReset() {
  }

  @Watch('model')
  @Watch('from')
  @Watch('to')
  private listenForReset() {
    if (this.filter.key) {
      if (this.model === void 0) {
        this.onReset()
      }
    } else if (this.filter.keys) {
      if (this.to === void 0 && this.from === void 0) {
        this.onReset()
      }
    }
  }

  onScroll({ to, ref }) {
    const items = this.resource
    if (!this.isPaginatable(items)) return
    if (
      !this.loading &&
      items.nextPage &&
      items.nextPage <= items.lastPage &&
      to === items.lastIndex
    ) {
      items
        .next()
        .then(() => {
          this.$nextTick(() => {
            ref.refresh()
          })
        })
    }
  }

  search(needle: string, update: () => void = () => {
  }) {
    if (
      this.isPaginatable(this.resource) &&
      !this.loading
    ) {
      this.resource
        .search(needle)
        .then(update)
    } else {
      update()
    }
  }

  isPaginatable(items?: Filter['items']): items is Paginatable<any> {
    return !!items && items instanceof Paginatable
  }

  isRemoteData(items?: Filter['items']): items is RemoteData<any> {
    return !!items && items instanceof RemoteData
  }

  get remoteData() {
    return this.isRemoteData(this.resource)
  }

  get paginatable() {
    return this.isPaginatable(this.resource)
  }

  get loading() {
    if (
      this.isRemoteData(this.resource) ||
      this.isPaginatable(this.resource)
    ) {
      return this.resource.isInProgress()
    } else {
      return false
    }
  }

  protected itemsMap(value: any) {
    return value
  }

  get items() {
    if (!this.resource) return null
    return Array.isArray(this.resource)
      ? this.resource
      // @ts-ignore
      : this.resource.fold(
        () => [],
        value => value ? this.itemsMap(value) : [],
        value => this.itemsMap(value),
        () => []
      )
  }

  mounted() {
    if (this.isPaginatable(this.resource)) {
      this.resource.next()
    }
  }
}
